module.exports = __webpack_public_path__ + "img/info-icon.8e304379.svg";